// import homePageStyle from "@src/assets/_libs/component/_c-page-home.module.scss";
// import subPageStyle from "@src/assets/_libs/component/_c-page-sub.module.scss";
// import sectionStyle from "@src/assets/_libs/layout/_l-section.module.scss"
import { BreadCrumb } from "@src/components/organisms/BreadCrumb";
import { Footer } from "@src/components/organisms/Footer";
// import { SideNav } from "@src/components/organisms/SideNav";
import { ComponentProps, ReactNode, useState } from "react";
import { Header } from "@src/components/organisms/Header";
import lMainStyle from "@src/assets/_libs/layout/_l-main.module.scss"

/**
 * header footerの詰め合わせ
 * ラッパーとして使用可能
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
export function DefaultTemplateWrapper(props: {
  header: ComponentProps<typeof Header>;
  footer: ComponentProps<typeof Footer>;
  children?: ReactNode;
}) {
  return (
    <div className="l-global-wrapper">
      {Header()}
      <main className={lMainStyle["l-main"]}>
        {props.children}
      </main>
      {Footer(props.footer)}
    </div>
  );
}
